import type { FC, PropsWithChildren } from 'react';

import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  toolbar: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'flex-end',
    margin: '0 auto',
    maxWidth: 2560,
    width: '100%',
  },
}));

type Props = {
  title?: string;
};

export const PageHeaderToolbar: FC<PropsWithChildren<Props>> = ({
  children,
  title = 'Page Toolbar',
}) => {
  const { classes } = useStyles();

  return (
    <section aria-label={title} className={classes.toolbar}>
      {children}
    </section>
  );
};
